import { render, staticRenderFns } from "./EmptyContentBlockForm.vue?vue&type=template&id=53076918&"
import script from "./EmptyContentBlockForm.vue?vue&type=script&lang=ts&"
export * from "./EmptyContentBlockForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports